<template>
  <div>
    <ProductPricing
        v-if="fullProductPrice"
        :full-product-price="fullProductPrice"
        :discounted-price="discountedPrice"
        :is-price-centered="false"
        :size="size"
      />
    <div :class="{'min-h-5': isPriceDisclaimerEnabled}">
      <PriceDisclaimer
        :is-discounted="isDiscounted"
        :last30-days-price="last30DaysPrice"
      />
    </div>
  </div>
</template>

<script lang="ts">

import { defineAsyncComponent } from 'vue';



import { PRODUCT_PRICING_SIZE } from '~~/constants/productCardPricing';
import type { ProductPricingSize } from '~~/constants/productCardPricing';

export default defineComponent({
  name: 'ProductCardPricing',
  components: {
    ProductPricing: defineAsyncComponent(() => import(
      '~/components/molecules/Product/ProductPricing/ProductPricing.vue')),
    PriceDisclaimer: defineAsyncComponent(() => import('~/components/molecules/Product/PriceDisclaimer.vue')),
  },
  props: {
    fullProductPrice: {
      type: Number,
      required: true,
    },
    discountedPrice: {
      type: Number,
      default: null,
    },
    isDiscounted: {
      type: Boolean,
      default: false,
    },
    last30DaysPrice: {
      type: Number,
      default: null,
    },
    size: {
      type: String as PropType<ProductPricingSize>,
      default: PRODUCT_PRICING_SIZE.DEFAULT,
      validator: (value: ProductPricingSize) => {

        return Object.values(PRODUCT_PRICING_SIZE).includes(value);

      },
    },
  },
  setup() {

    const { isPriceDisclaimerEnabled } = usePriceDisclaimer();

    return {
      isPriceDisclaimerEnabled,
    };

  },
});

</script>
